import {Injectable} from "@angular/core";
import {ApiService} from "app/services/domain/api.service";
import {batchInChunks} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";

@Injectable({
                providedIn: "root"
            })
export class AppInsightsService
{
    constructor(private m_api: ApiService)
    {}

    private m_cacheVulnerabilityDetails: Map<string, Models.AppSecopsVulnerability> = new Map();

    async getAppSecOpsVulnerability(vulnerabilityId: string): Promise<Models.AppSecopsVulnerability>
    {
        const cached = this.m_cacheVulnerabilityDetails.get(vulnerabilityId);
        if (cached)
        {
            return cached;
        }

        const vulnerability = await this.batchAppSecOpsVulnerabilities([vulnerabilityId]);

        this.m_cacheVulnerabilityDetails.set(vulnerabilityId, vulnerability[0]);

        return vulnerability[0];
    }


    async batchAppSecOpsVulnerabilities(vulnerabilityIds: string[]): Promise<Models.AppSecopsVulnerability[]>
    {
        const cached: Models.AppSecopsVulnerability[] = [];
        const missing: string[]                       = [];

        for (const id of vulnerabilityIds)
        {
            const cachedVuln = this.m_cacheVulnerabilityDetails.get(id);
            if (cachedVuln)
            {
                cached.push(cachedVuln);
            }
            else
            {
                missing.push(id);
            }
        }

        let fetched: Models.AppSecopsVulnerability[] = [];
        if (missing.length)
        {
            fetched = await this.batchVulnerabilities(missing);

            for (const vuln of fetched)
            {
                this.m_cacheVulnerabilityDetails.set(vuln.id, vuln);
            }
        }
        return [
            ...cached,
            ...fetched
        ];
    }

    public async batchVulnerabilities(vulnerabilityIds: string[]): Promise<Models.AppSecopsVulnerability[]>
    {
        return batchInChunks(vulnerabilityIds,
                             (chunk) => this.m_api.appSecOps.batchVulnerabilities(Models.ObjectIdBatchRequest.newInstance({ids: chunk})));
    }

    public getVulnAge(date: Date): string
    {
        const currentDate = new Date();
        return (Math.floor((currentDate.getTime() - new Date(date).getTime()) / (1000 * 60 * 60 * 24))).toString();
    }
}
